import { BrandConfig } from 'branding/types'

// Solution to update old-knockout style buttons to use the GoodSam colors
// basically only for the older WTD Deal Structure
function updateButtonColors(isCWCaptive = false) {
    if (isCWCaptive) {
        document.documentElement.style.setProperty(
            '--primary-color-start',
            getComputedStyle(document.documentElement).getPropertyValue(
                '--alternate-color-start',
            ),
        )

        document.documentElement.style.setProperty(
            '--primary-color-end',
            getComputedStyle(document.documentElement).getPropertyValue(
                '--alternate-color-end',
            ),
        )
    } else {
        document.documentElement.style.setProperty(
            '--primary-color-start',
            getComputedStyle(document.documentElement).getPropertyValue(
                '--primary-color-start',
            ),
        )

        document.documentElement.style.setProperty(
            '--primary-color-end',
            getComputedStyle(document.documentElement).getPropertyValue(
                '--primary-color-end',
            ),
        )
    }
}

export function applyBrandConfig(
    brandConfig: BrandConfig = {} as BrandConfig,
): void {
    const faviconPath = brandConfig.faviconUrl ?? ''
    const faviconDarkPath = brandConfig.faviconDarkUrl ?? ''

    if (faviconPath) {
        const head = document.querySelector('head')

        if (head) {
            const existingIcons = head.querySelectorAll(
                'link[rel="icon"], link[rel="shortcut icon"]',
            )

            existingIcons.forEach((icon) => head.removeChild(icon))

            const link = document.createElement('link')

            link.rel = 'icon'
            link.href = faviconPath
            head.insertBefore(link, head.firstChild)

            if (faviconDarkPath) {
                const darkLink = document.createElement('link')

                darkLink.rel = 'icon'
                darkLink.href = faviconDarkPath
                darkLink.media = '(prefers-color-scheme: dark)'
                head.insertBefore(darkLink, link.nextSibling)
            }
        }
    }

    if (brandConfig.pageTitle) {
        document.title = brandConfig.pageTitle
    }

    const isCWCaptive = brandConfig?.identifier === 'goodsam'

    updateButtonColors(isCWCaptive)
}
